<template>
  <!-- Główny kontener dla widoku VMS (tablica znaków zmiennej treści) -->
  <div class="content-container">
    <!-- Panel filtrów danych VMS (lewa kolumna) -->
    <filter-vms-data />
    <div class="content-wrap">
      <!-- Lista grup VMS (przekazuje statusy i opisy grup jako propsy) -->
      <vms-list 
        :group-statuses="vmsStore.groupStatuses"
        :group-descriptions="vmsStore.groupDescriptions"
      />
    </div>
  </div>
</template>

<script>
// Import wymaganych komponentów i Pinia Store
import VmsList from "@/components/Vms";
import { useVmsStore } from "@/stores/vms";
import FilterVmsData from "@/components/FilterVmsData.vue";

export default {
  name: "VmsView",
  components: {
    VmsList,           // Komponent listy znaków VMS
    FilterVmsData,     // Panel boczny z filtrami
  },
  setup() {
    // Ładowanie Pinia store z danymi VMS (statusy, opisy)
    const vmsStore = useVmsStore();
    // Store używany do przekazania statusów i opisów do komponentu VmsList
    return { vmsStore };
  },
  data() {
    return {
      // (Nieużywane, zostawione z szablonu, można usunąć)
      groupStatuses: [],
    };
  },
};
</script>

<style scoped>
/* Główne tło widoku VMS */
.content-container {
  background-color: var(--surface-secondary);
}

/* Stylowanie przycisków i akcji (część wspólnego stylu aplikacji) */

/* Przyciski typu "dalej" */
.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: var(--text-secondary);
}
.btn-next:hover {
  color: var(--text-primary);
}
/* Sekcja akcji (dół/ góra) */
.actions, .actions-down {
  background-color: var(--surface-primary);
  width: 100%;
}

.actions .btn-prev, .actions-down .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: var(--text-secondary);
}
.actions .btn-prev:hover, .actions-down .btn-prev:hover {
  color: var(--text-primary);
}
.actions-down {
  margin-top: 2rem !important;
}
</style>
